import { useContext } from 'react'

import { GeneratorClientProposalContext } from './GeneratorClientProposalContext'

export const useGeneratorClientProposalContext = () =>
  useContext(GeneratorClientProposalContext)
